<template>
  <section class="dfdSaves-wrapper-v2">
    <div
      class="genplan-modal"
      :class="{more: flat.apartment_type.entrance?.modal}"
    >
      <div class="modal">
        <template v-if="flat.apartment_type.entrance?.modal">
          <div class="genplan-modal__header">
            {{ title }}
          </div>
          <div
            v-if="flat.apartment_type.entrance.modal.street"
            class="genplan-modal__header-sub"
          >
            {{ $realty(flat.apartment_type.entrance.modal.street) }}
          </div>
          <div class="genplan-modal__plan">
            <div
              class="genplan-modal__plan-img"
              :style="`background-image: url(${flat.preview_modal});`"
            />
            <div class="genplan-modal__plan-info">
              <div class="genplan-modal__plan-top">
                <div class="genplan-modal__plan-item">
                  <div class="genplan-modal__plan-prop">
                    {{ $t('Square') }}
                  </div>
                  <div class="genplan-modal__plan-value">
                    {{ flat.properties.square }}
                  </div>
                </div>
                <div class="genplan-modal__plan-item">
                  <div class="genplan-modal__plan-prop">
                    {{ $t('Floor') }}
                  </div>
                  <div class="genplan-modal__plan-value">
                    {{ flat.apartment_type.entrance.modal.floor }}
                  </div>
                </div>
                <div
                  v-if="flat.apartment_type.entrance.modal.deadline"
                  class="genplan-modal__plan-item"
                >
                  <div class="genplan-modal__plan-prop">
                    {{ $t('timeEnd') }}
                  </div>
                  <div class="genplan-modal__plan-value">
                    {{ flat.apartment_type.entrance.modal.deadline }}
                  </div>
                </div>
                <div
                  v-if="flat.apartment_type.entrance.modal.hull"
                  class="genplan-modal__plan-item"
                >
                  <div class="genplan-modal__plan-prop">
                    {{ $t('hull') }}
                  </div>
                  <div class="genplan-modal__plan-value">
                    {{
                      $t('hull') +
                      ' ' +
                      flat.apartment_type.entrance.modal.hull
                    }}
                  </div>
                </div>
                <div class="genplan-modal__plan-item">
                  <div class="genplan-modal__plan-prop">
                    {{ $t('section') }}
                  </div>
                  <div class="genplan-modal__plan-value">
                    {{
                      $t('Entrance') +
                      ' ' +
                      flat.apartment_type.entrance.modal.section
                    }}
                  </div>
                </div>
              </div>
              <div
                v-if="flat.apartment_type.entrance.modal.properties"
                class="genplan-modal__plan-params"
              >
                <div
                  v-for="(place, idx) in Object.keys(
                    flat.apartment_type.entrance.modal.properties,
                  )"
                  :key="idx"
                  class="genplan-modal__plan-item"
                >
                  <div
                    class="genplan-modal__plan-prop"
                    v-if="isMounted"
                  >
                    {{ $realty(place) }}
                  </div>
                  <div class="genplan-modal__plan-value">
                    {{
                      flat.apartment_type.entrance.modal
                        ?.properties?.[place]
                    }}
                    м²
                  </div>
                </div>
              </div>

              <a
                v-if="
                  flat.apartment_type.entrance.modal.developer_site
                "
                target="_blank"
                :href="
                  flat.apartment_type.entrance.modal.developer_site
                "
                class="genplan-modal__plan-link"
              >
                {{ $t('goToSite') }}
              </a>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="genplan-modal__header">
            {{ title }}
          </div>
          <div class="genplan-modal__images">
            <swiper
              :slides-per-view="1"
              :pagination="{
                clickable: true,
              }"
              :navigation="false"
            >
              <swiper-slide
                v-for="(image, index) in images"
                :key="image + index"
              >
                <img
                  :src="image"
                  class="genplan-modal__images-item"
                  alt=""
                />
              </swiper-slide>
            </swiper>
          </div>
          <div
            v-if="flat.apartment_type.entrance?.modal"
            class="genplan-modal__info"
          >
            <div
              v-if="flat.apartment_type.entrance?.modal.street"
              class="genplan-modal__subtitle"
            >
              {{
                $realty(flat.apartment_type.entrance?.modal.street)
              }}
            </div>
            <div class="genplan-modal__info-content">
              <div class="genplan-modal__info-name">
                {{ $t('Square') }}
              </div>
              <div class="genplan-modal__info-prop">
                {{ flat.properties.square }}
              </div>
            </div>
            <div class="genplan-modal__info-content">
              <div class="genplan-modal__info-name">
                {{ $t('House') }}
              </div>
              <div class="genplan-modal__info-prop">
                {{ flat.apartment_type.entrance.modal.house }}
              </div>
            </div>
            <div class="genplan-modal__info-content">
              <div class="genplan-modal__info-name">
                {{ $t('section') }}
              </div>
              <div class="genplan-modal__info-prop">
                {{ flat.apartment_type.entrance.modal.section }}
              </div>
            </div>

            <ExternalLink
              :to="flat.apartment_type.entrance.modal.developer_site"
              class="genplan-modal__info-site"
            >
              {{ $t('goToSite') }}
              <IconLink />
            </ExternalLink>
          </div>
        </template>
      </div>
    </div>
  </section>
  <InterierSection />
  <div class="actions">
    <ui-button
      color="primary"
      :label="$t('viewInDreamFlat')"
      @click="openLauncher()"
      style="width: 184px"
    />
  </div>
</template>

<script setup lang="ts">
import {useBaseStore} from '~/modules/BaseModule/base.store';
import InterierSection from '~/modules/RealEstate/components/InterierSection.vue';
const isMounted = ref(false);
const base = useBaseStore();
const isBeta = ref(false);
const flat = {
  apartment_type: {
    entrance: {
      modal: {
        deadline: '',
        developer_site: 'https://mon-arch.ru/',
        floor: '3',
        house: '1',
        hull: '1',
        properties: {
          bathroom3: '4.2',
          bathroom32: '3.0',
          corridor: '12.4',
          corridor2: '2.0',
          dressing: '3.3',
          dressing2: '2.9',
          kitchen: '22.0',
          room: '16.7',
          room2: '14.5',
          room3: '14.5',
        },

        section: '1',
        street: '',
      },
      points:
        '686.495,32.9492 437.764,32.9492 437.764,176.005 521.444,176.005 521.444,241.325 604.236,241.325 604.236,388.469 687.383,388.469 687.383,234.225 685.251,234.225 685.251,176.005 686.495,176.005 686.495,32.9492',
    },
  },
  floor_uuid: '391f0a94277f4d739b7d71b15972083f',
  gallery: [],
  house_uuid: null,
  name: '3r 1',
  preview:
    'https://work.dreamflat.design/storage/admin_panel/data/real_estate//apartment/296475d6-ed77-4c0f-90b4-ca472cbfe62c/preview/filename.png',
  preview_modal:
    'https://work.dreamflat.design/storage/admin_panel/data/real_estate//apartment/296475d6-ed77-4c0f-90b4-ca472cbfe62c/preview_modal/1_1.svg',
  properties: {
    room_count: '1',
    square: '95.5',
  },
  real_estate_uuid: null,
  saves: {
    dfdSave: [
      'https://work.dreamflat.design/storage/admin_panel/data/real_estate//apartment/296475d6-ed77-4c0f-90b4-ca472cbfe62c/dfdSave/001.jpeg',
      'https://work.dreamflat.design/storage/admin_panel/data/real_estate//apartment/296475d6-ed77-4c0f-90b4-ca472cbfe62c/dfdSave/001.sv',
      'https://work.dreamflat.design/storage/admin_panel/data/real_estate//apartment/296475d6-ed77-4c0f-90b4-ca472cbfe62c/dfdSave/01-dev.jpeg',
      'https://work.dreamflat.design/storage/admin_panel/data/real_estate//apartment/296475d6-ed77-4c0f-90b4-ca472cbfe62c/dfdSave/01-dev.sv',
      'https://work.dreamflat.design/storage/admin_panel/data/real_estate//apartment/296475d6-ed77-4c0f-90b4-ca472cbfe62c/dfdSave/new-001.jpeg',
      'https://work.dreamflat.design/storage/admin_panel/data/real_estate//apartment/296475d6-ed77-4c0f-90b4-ca472cbfe62c/dfdSave/new-001.sv',
    ],
    meta: [
      'https://work.dreamflat.design/storage/admin_panel/data/real_estate//apartment/296475d6-ed77-4c0f-90b4-ca472cbfe62c/meta/755c3c66-4ec8-490a-acb5-72bb81be5ebf.fbx',
      'https://work.dreamflat.design/storage/admin_panel/data/real_estate//apartment/296475d6-ed77-4c0f-90b4-ca472cbfe62c/meta/755c3c66-4ec8-490a-acb5-72bb81be5ebf.json',
    ],
    save: [
      'https://work.dreamflat.design/storage/admin_panel/data/real_estate//apartment/296475d6-ed77-4c0f-90b4-ca472cbfe62c/save/755c3c66-4ec8-490a-acb5-72bb81be5ebf.json',
    ],
  },

  uuid: '296475d6ed774c0f90b4ca472cbfe62c',
  visible: true,
};

const openLauncher = () => {
  const getUUid = '296475d6ed774c0f90b4ca472cbfe62c';
  const fileName = '001';
  const url = `df-launcher${
    isBeta.value ? '-beta' : ''
  }://open_realty_save?jwt=${
    useCookie('df').value
  }&uuidApartament=${getUUid}&saveName=${fileName}&nameRC=${'Yakovlevo'}`;

  console.log(url);

  location.href = url;
};

onMounted(() => {
  isBeta.value =
    location.href.includes('work') ||
    location.href.includes('localhost') ||
    location.href.includes('127.0.0.1');
  isMounted.value = true;
});
</script>

<style scoped lang="scss">
.genplan-modal {
  height: 100%;
  width: 100%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  padding: 0px 0px 20px 0px;

  .modal {
    padding: 0px;
    max-width: 798px;
    width: 100%;
    height: 569px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
  }

  &__header {
    text-align: left;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: #3d424a;
    margin-bottom: 12px;
  }

  &__image {
    width: 400px;
    height: 226px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top;
    border-radius: 16px;
    margin-bottom: 16px;
  }

  .swiper-slide {
    padding: 0px;
  }

  &__images {
    &-item {
      width: 100%;
      height: 421px;
      object-fit: cover;
      border-radius: 8px;
      display: block;
    }
  }

  &.more &__images-item {
    height: 225px;
  }

  &.more {
    .modal {
      max-width: 798px;
      width: 100%;
      height: initial;
    }
  }

  ::v-deep(.swiper-wrapper) {
    padding-bottom: 0;
  }

  &.more &__info-site {
    margin-top: 12px;
  }

  &__info {
    &-content {
      display: flex;

      & + & {
        margin-top: 8px;
      }
    }

    &-prop {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.02em;
      text-align: left;
    }

    &-name {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.02em;
      color: #7f97aa;
      width: 200px;
      text-align: left;
    }

    &-site {
      font-weight: 400;
      font-size: 13px;
      line-height: 18px;
      letter-spacing: 0.02em;
      color: #3e9eea;
      text-align: left;
      text-decoration: none;
      display: flex;
      align-items: center;
      gap: 6px;
    }
  }

  &__subtitle {
    text-align: left;
    margin-bottom: 12px;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.02em;
    color: #ffffff;
    margin-top: 24px;
  }

  &__action {
    margin-top: auto;
    justify-self: flex-end;
    align-self: flex-end;
    display: flex;
    gap: 8px;
    width: 100%;

    &--close {
      margin-right: auto;
    }
  }
}

.genplan-modal__plan {
  display: flex;
  gap: 36px;
  margin-top: 16px;
  margin-bottom: 32px;

  @media (max-width: $lg) {
    flex-direction: column;
  }

  &-img {
    width: 355px;
    height: 332px;
    background-size: contain;
    background-position: top left;
    background-repeat: no-repeat;
  }

  &-info {
    //width: calc(50% - 18px);
    flex: 1;
  }

  &-top {
    display: flex;
    justify-content: space-between;

    .genplan-modal__plan-prop {
      margin-top: 4px;
    }
  }

  &-params {
    margin-top: 34px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-height: 160px;
    overflow: auto;
    padding-bottom: 16px;
    padding-right: 16px;

    &::-webkit-scrollbar {
      position: absolute;
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      position: absolute;
      background-color: transparent;
    }

    &::-webkit-scrollbar-button:single-button {
      width: 10px;
      height: 10px;
      position: absolute;
      background: transparent;
      background-repeat: no-repeat;
      background-size: 5px;
      background-position-x: 50%;
      transition: background 0.3s ease;
    }

    &::-webkit-scrollbar-thumb {
      position: absolute;
      background-color: #a5a7ab;
      border-radius: 32px;
    }

    .genplan-modal__plan-item {
      display: flex;
      justify-content: space-between;
      overflow: visible;
    }

    .genplan-modal__plan-prop {
      text-align: left;
    }
  }
}

.genplan-modal__plan-prop {
  color: #7f97aa;
  text-align: center;
  font-size: 12px;
}

.genplan-modal__plan-value {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.28px;
}

.genplan-modal__plan-price {
  margin-top: 53px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .genplan-modal__plan-price--name {
    font-size: 16px;
    line-height: 140%;
    letter-spacing: 0.48px;
  }

  .genplan-modal__plan-price--item {
    color: #3e9eea;
    text-align: right;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 0.72px;
  }
}

.genplan-modal__plan-link {
  margin-top: 4px;
  text-align: left;
  color: #3e9eea;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.26px;
}

.genplan-modal__header-sub {
  margin-top: -12px;
  color: #839aaf;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.28px;
  text-align: left;
}
</style>
